import { ctor } from 'from2';
import { async } from 'regenerator-runtime';
import {
  req,
  imgServer,
  googlePlaceDataAPI,
  getWebsiteData,
} from '../js/config';
import { currencyFormatter } from '../js/base';
//import { ToHTML, ToHTMLWithFormatting } from "../js/base";
//import { async } from "regenerator-runtime";
let PageData = {};
const Initialize = async () => {
  try {
    await getPageData();
    console.log('getPageData', PageData);

    await generatePageHTML();

    await loadJavascriptNow();

    const loader = document.querySelector('.loader');
    loader.className += ' hidden'; // class "loader
  } catch (err) {
    console.log('🚀 ~ file: main.js:21 ~ Initialize ~ err', err);

    window.location = 'index.html';
  }
};

const getPageData = async () => {
  let WebData = await getWebsiteData();
  PageData = WebData.filter((x) => x.attributes.Status === 'Available');
};

const generatePageHTML = async () => {
  document.querySelector('#copyrightYearsFooter').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  document.querySelector('#copyrightYearsMobileMenu').innerHTML =
    '&copy;' +
    new Date().getFullYear() +
    ' <span> Hansen Truck & Car Sales</span';
  let testimonials = await googlePlaceData();

  if (testimonials != null) {
    await updateCurrentDayHours(testimonials.opening_hours);

    await phoneNumber(testimonials.formatted_phone_number);

    await address(testimonials.formatted_address);
  }
};

const updateCurrentDayHours = async (h) => {
  let currentDay = new Date().getDay();
  currentDay == 0 ? (currentDay = 7) : currentDay;

  document.querySelector('#currentDayHours').innerHTML =
    h.weekday_text[currentDay - 1];

  let tpa = '';
  for (let i = 0; i < h.weekday_text.length; i++) {
    tpa += `<li>${h.weekday_text[i]}</li>`;
  }
  document.querySelector('#workingHours').innerHTML = tpa;
};
const phoneNumber = async (p) => {
  document.querySelector('#phoneNumber').innerHTML =
    '<a href="tel:+' + p.replace(/[\s\-\(\)]+/g, '') + ' "> ' + p + '</a>';
  document.querySelector('#footerPhoneNumber').innerHTML =
    '<a href="tel:+' + p.replace(/[\s\-\(\)]+/g, '') + ' "> ' + p + '</a>';
};
//<a href="geo:37.421999,-122.0862462" target="_blank">
//Visit Us: 1600 Amphitheatre Parkway, Mountain View, CA
//</a>

const address = async (a) => {
  document.querySelector('#address').innerHTML =
    '<a href="https://www.google.com/maps?q=' +
    a +
    '" target="_blank">' +
    a +
    '</a>';
  document.querySelector('#footerAddress').innerHTML =
    '<a href="https://www.google.com/maps?q=' +
    a +
    '" target="_blank">' +
    a +
    '</a>';
};
const googlePlaceData = async () => {
  const data = await googlePlaceDataAPI();
  console.log('🚀 ~ file: main.js ~ line 162 ~ googlePlaceData ~ data', data);
  return data;
};

const loadJavascriptNow = async () => {
  const script = document.createElement('script');
  script.src = 'assets/js/main.js';

  // Append to the `head` element
  document.head.appendChild(script);
};

Initialize();
